module.exports = __webpack_public_path__ + "static/media/trophyWrong.efe08a4f.png";